import { render, staticRenderFns } from "./shopinfo.vue?vue&type=template&id=ac13cd50&scoped=true&"
import script from "./shopinfo.vue?vue&type=script&lang=js&"
export * from "./shopinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac13cd50",
  null
  
)

export default component.exports